export default __webpack_public_path__ + "static/media/delete.4ff0aaee.svg";